import { createTheme } from '@mantine/core'
import AccordionTheme from './components/Accordion'
import ButtonTheme from './components/Button'
import DividerTheme from './components/Divider'
import { InputTheme, InputWrapperTheme } from './components/Input'
import ProgressTheme from './components/Progress'
import TitleTheme from './components/Title'
import RadioCardTheme from './components/RadioCard'
import RadioIndicatorTheme from './components/RadioIndicator'
import TextareaTheme from './components/Textarea'

// In Storybook, mercyTheme inherits rebrand, which sets different values that override anything we've defined here and in the CSS resolver.
// Use defaultProps and other properties in createTheme() as the "more specific" layer to ensure that component-specific styling will always win.
// It is also a good stopgap in case the theme inherits rebrand in production.
export const mercyTheme = createTheme({
    /** Set default --mantine-font-family token and any read of theme.fontFamily */
    fontFamily: 'var(--gm-font-family)',
    headings: {
        /** Title reads its own font family, override here */
        fontFamily: 'var(--gm-font-family)',
        sizes: {
            h1: {
                fontSize: 'var(--gm-heading-h1-font-size)',
                fontWeight: 'var(--gm-heading-h1-font-weight)',
                lineHeight: 'var(--gm-heading-h1-line-height)',
            },
            h2: {
                fontSize: 'var(--gm-heading-h2-font-size)',
                fontWeight: 'var(--gm-heading-h2-font-weight)',
                lineHeight: 'var(--gm-heading-h2-line-height)',
            },
            h3: {
                fontSize: 'var(--gm-heading-h3-font-size)',
                fontWeight: 'var(--gm-heading-h3-font-weight)',
                lineHeight: 'var(--gm-heading-h3-line-height)',
            },
            h4: {
                fontSize: 'var(--gm-heading-h4-font-size)',
                fontWeight: 'var(--gm-heading-h4-font-weight)',
                lineHeight: 'var(--gm-heading-h4-line-height)',
            },
            h5: {
                fontSize: 'var(--gm-heading-h5-font-size)',
                fontWeight: 'var(--gm-heading-h5-font-weight)',
                lineHeight: 'var(--gm-heading-h5-line-height)',
            },
        },
    },
    components: {
        Accordion: AccordionTheme,
        Button: ButtonTheme,
        Title: TitleTheme,
        Badge: {
            defaultProps: {
                size: undefined,
                radius: undefined,
                variant: undefined,
                color: undefined,
            },
            // Drop rebrand's classNames - they're setting default typography
            classNames: undefined,
        },
        Divider: DividerTheme,
        Input: InputTheme,
        InputWrapper: InputWrapperTheme,
        Progress: ProgressTheme,
        RadioCard: RadioCardTheme,
        RadioIndicator: RadioIndicatorTheme,
        Textarea: TextareaTheme,
    },
})

export default mercyTheme
